

import Vue from 'vue'
import CandidateProfile from '@/views/learner/CandidateProfile.vue'

export default Vue.extend({
  name: 'ProfilePreview',
  components: {
    CandidateProfile
  },
  data: () => ({
    previousRouteName: '',
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // If the previous route was from one of the profile edit pages, direct them back to the page they were on
      if (from.meta.navSectioni18n === 'profile') {
        (vm as any).previousRouteName = from.name as string
      }
    })
  },
})
